const isDev = process.env.REACT_APP_IS_DEV !== undefined
    ? process.env.REACT_APP_IS_DEV === 'true'
    : (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const config = {
    API_URL: process.env.REACT_APP_API_URL || (isDev ? 'http://localhost:8080/api/' : '/api/'),
    ADMIN_URL: process.env.REACT_APP_ADMIN_URL || (isDev ? 'http://localhost:8080/admin/' : '/admin/'),
    IS_DEV: isDev,
};

console.log('Config:', config);

export default config;